module.exports = __webpack_public_path__ + "img/jungle_1_TA.c46015c0.png";